import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './../styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { monthNames } from 'src/utils/date';
import { useTranslation } from 'react-i18next';
import { Button, Chip, Menu } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CorrectionsDetails from './CorrectionsDetails';
import { Icon, toast } from '@livable/saas-react-components';
import { AbsorbAdjustmentsModal } from './AbsorbAdjustmentsModal';
import { AdditionalChargesCreditsModal } from './AdditionalChargesCreditsModal';
export const AdditionalChargesAndcredits = observer(_ref => {
  let allocationCycleId = _ref.allocationCycleId,
    propertyId = _ref.propertyId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const correctionsDetails = store.corrections.correctionsDetails.get(allocationCycleId) || {};
  const correctionAllocationCycles = (correctionsDetails === null || correctionsDetails === void 0 ? void 0 : correctionsDetails.correctionAllocationCycles) || [];
  const correctionId = correctionsDetails.correctionId,
    correctionSummary = correctionsDetails.correctionSummary,
    isExcluded = correctionsDetails.isExcluded;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenAdditionalChargesCreditsModal = _useState2[0],
    setIsOpenAdditionalChargesCreditsModal = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpenAbsorbAdjustmentsModal = _useState4[0],
    setIsOpenAbsorbAdjustmentsModal = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpenDetailsModal = _useState6[0],
    setIsOpenDetailsModal = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    anchorEl = _useState8[0],
    setAnchorEl = _useState8[1];
  const open = Boolean(anchorEl);
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const getCorrectionsDetails = async () => {
    const resp = await store.corrections.getCorrectionsDetailsAsync.run({
      allocationCycleId,
      propertyId
    });
    return resp;
  };
  const postExcludeCorrection = async () => {
    const resp = await store.allocations.postExcludeCorrectionAsync.run({
      correctionId
    });
    return resp;
  };
  const postIncludeCorrection = async () => {
    const resp = await store.allocations.postIncludeCorrectionAsync.run({
      correctionId
    });
    return resp;
  };
  const adjustmentsSwitch = async value => {
    Promise.all([value ? postExcludeCorrection() : postIncludeCorrection()]).then(() => {
      toast('success', {
        body: [t("corrections.".concat(value ? 'exclude' : 'include', "_success"))]
      });
      getCorrectionsDetails();
    });
  };
  useEffect(() => {
    getCorrectionsDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, correctionId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyAdditionalChargesAndcredits,
    onClick: () => setIsOpenAdditionalChargesCreditsModal(true)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyAdditionalChargesAndcreditsWarning
  }, /*#__PURE__*/React.createElement(Chip, {
    label: "".concat(isExcluded ? "You absorb adjustments. Under-billed residents won't be charged extra, and over-billed residents won't get extra credit." : 'Your retroactive actions caused billing errors. Additional charges/credits have been added in the current cycle for residents affected.'),
    variant: "".concat(isExcluded ? 'inactive' : 'warning')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionBodyItemInfoIcon, " ").concat(isExcluded ? classes.disabled : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetailsTitle
  }, /*#__PURE__*/React.createElement("b", {
    className: isExcluded ? classes.disabled : ''
  }, "Additional charges/credits"), isExcluded && /*#__PURE__*/React.createElement(Chip, {
    label: "Absorbed",
    variant: "inactive"
  })), /*#__PURE__*/React.createElement("i", null, "Due to adjustments for", ' ', correctionAllocationCycles.map(c => "".concat(monthNames[c.month - 1].slice(0, 3), " ").concat(c.year)).join(', ')))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemControl
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.priceInfo, " ").concat(isExcluded ? classes.disabled : '')
  }, Number.isFinite(correctionSummary === null || correctionSummary === void 0 ? void 0 : correctionSummary.absorption) ? "$".concat(correctionSummary === null || correctionSummary === void 0 ? void 0 : correctionSummary.absorption.toFixed(2)) : 'N/A')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '591-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {
      handleClose();
      setIsOpenDetailsModal(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-on"
  }), t('corrections.view_details')), !isExcluded && /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      handleClose();
      setIsOpenAbsorbAdjustmentsModal(true);
    },
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "stop-play"
  }), "Absorb adjustments"), isExcluded && /*#__PURE__*/React.createElement(Button, {
    onClick: async () => {
      handleClose();
      await adjustmentsSwitch(false);
    },
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus-circle"
  }), "Include adjustments back")))))), /*#__PURE__*/React.createElement(CorrectionsDetails, {
    allocationCycleId: allocationCycleId,
    isOpenExternal: isOpenDetailsModal,
    correctionSummary: correctionSummary,
    isExcluded: isExcluded,
    handleModalCloseExt: () => setIsOpenDetailsModal(false)
  }), /*#__PURE__*/React.createElement(AdditionalChargesCreditsModal, {
    correctionSummary: correctionSummary,
    isExcluded: isExcluded,
    absorbAdjustments: () => {
      setIsOpenAdditionalChargesCreditsModal(false);
      setTimeout(() => {
        setIsOpenAbsorbAdjustmentsModal(true);
      }, 0);
    },
    includeAdjustments: async () => {
      setIsOpenAdditionalChargesCreditsModal(false);
      await adjustmentsSwitch(false);
    },
    isOpenExternal: isOpenAdditionalChargesCreditsModal,
    handleModalCloseExt: () => setIsOpenAdditionalChargesCreditsModal(false),
    showDetails: () => {
      setIsOpenAdditionalChargesCreditsModal(false);
      setTimeout(() => {
        setIsOpenDetailsModal(true);
      }, 0);
    }
  }), /*#__PURE__*/React.createElement(AbsorbAdjustmentsModal, {
    handleSubmit: async () => {
      await adjustmentsSwitch(true);
      setIsOpenAbsorbAdjustmentsModal(false);
    },
    correctionId: correctionId,
    isOpenExternal: isOpenAbsorbAdjustmentsModal,
    handleModalCloseExt: () => setIsOpenAbsorbAdjustmentsModal(false)
  })));
});